/* eslint-disable no-unused-vars */
/* eslint-disable no-new */

import BadgerAccordion from 'badger-accordion'

export default () => {
    const accordions = document.querySelectorAll('.js-accordion')

    if (accordions.length) {
        accordions.forEach(element => {
            const accordion = new BadgerAccordion(element)
        })
    }
}
